import { render } from "./LayerNoConsent.vue?vue&type=template&id=e8004f3c&scoped=true&ts=true"
import script from "./LayerNoConsent.vue?vue&type=script&lang=ts"
export * from "./LayerNoConsent.vue?vue&type=script&lang=ts"

import "./LayerNoConsent.vue?vue&type=style&index=0&id=e8004f3c&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8004f3c"]])

export default __exports__